import { queryOptions } from '@tanstack/react-query';

import {
  fetchDashboardConfig,
  fetchSharedDashboardConfig,
  isDashboardNotFoundError
} from './dashboard.api';

export const dashboardOptions = {
  all: () => ['dashboard'] as const,
  sharedAll: () => ['shared-dashboard'] as const,

  mutations: {
    all: () => [...dashboardOptions.all(), 'mutation'] as const,
    addWidget: () => [...dashboardOptions.mutations.all(), 'add-widget'] as const,
    create: () => [...dashboardOptions.mutations.all(), 'create'] as const,
    delete: (dashboardName: string) =>
      [...dashboardOptions.mutations.all(), 'delete', dashboardName] as const,
    generateShareLink: (dashboardName: string) =>
      [...dashboardOptions.mutations.all(), 'generate-share-link', dashboardName] as const,
    save: () => [...dashboardOptions.mutations.all(), 'save'] as const,
    sendShareEmail: () => [...dashboardOptions.mutations.all(), 'send-share-email'] as const,
    updateAll: () => [...dashboardOptions.mutations.all(), 'update'] as const,
    update: (dashboardName: string, oldDashboardName?: string) =>
      [...dashboardOptions.mutations.updateAll(), dashboardName, oldDashboardName ?? null] as const
  },

  list: () =>
    queryOptions({
      queryKey: dashboardOptions.all(),
      queryFn: ({ signal }) => fetchDashboardConfig(signal),
      retry: (failureCount, error) => {
        if (isDashboardNotFoundError(error)) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Infinity,
      structuralSharing: false
    }),

  shared: (shareToken: string | null) =>
    queryOptions({
      queryKey: [...dashboardOptions.sharedAll(), shareToken ?? ''] as const,
      queryFn: ({ signal }) => fetchSharedDashboardConfig(shareToken, signal),
      enabled: !!shareToken,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      structuralSharing: false
    })
};
